import { Controller } from 'stimulus'
import { whenMapsReady } from '../../src/javascripts/google_maps_utils'

const MAP_OPTIONS = {
  zoom: 14,
  streetViewControl: false,
  disableDefaultUI: true,
  mapTypeControlOptions: { mapTypeIds: ['roadmap', 'hybrid'] },
}

const CIRCLE_OPTIONS = {
  strokeColor: '#2BB096',
  strokeOpacity: 0.8,
  strokeWeight: 2,
  fillColor: '#2BB096',
  fillOpacity: 0.35,
  radius: 600,
}

export default class extends Controller {
  static targets = ['map', 'modal', 'time', 'name', 'localTime', 'select', 'regionButton']

  connect() {
    this.abortController = new AbortController()
    const { signal } = this.abortController

    if (this.isDialogModal()) {
      this.modalTarget.addEventListener(
        'toggle',
        (event) => {
          if (event.newState === 'open') whenMapsReady(() => this.onDialogOpen())
        },
        { signal }
      )
      return
    }

    whenMapsReady(() => this.selectRegion())
  }

  disconnect() {
    this.abortController?.abort()
  }

  isDialogModal() {
    return this.hasModalTarget && this.modalTarget.tagName === 'DIALOG'
  }

  onDialogOpen() {
    this.selectRegion()
    if (this.map) google.maps.event.trigger(this.map, 'resize')
  }

  selectRegion() {
    if (this.hasSelectTarget) {
      const option = this.selectTarget.options[this.selectTarget.selectedIndex]
      this.applySelectedRegion(this.regionDataFrom(option))
      this.updateSelectOptionLabels()
    } else if (this.hasRegionButtonTarget) {
      const activeButton =
        this.regionButtonTargets.find((button) => button.classList.contains('btn-neutral')) ||
        this.regionButtonTargets[0]
      if (activeButton) this.applySelectedRegion(this.regionDataFrom(activeButton))
    }
  }

  selectRegionFromButton(event) {
    event.preventDefault()
    const button = event.currentTarget
    this.applySelectedRegion(this.regionDataFrom(button))
    this.updateRegionButtonStates(button)
  }

  applySelectedRegion(region) {
    whenMapsReady(() => {
      this.ensureMap()
      this.renderTime(region)

      if (!this.map || !this.circle) return

      const center = { lat: region.latitude, lng: region.longitude }
      this.circle.setCenter(center)
      this.map.setCenter(center)
    })
  }

  regionDataFrom(element) {
    return {
      name: element.dataset.name || element.getAttribute('data-name'),
      latitude: parseFloat(element.dataset.latitude || element.getAttribute('data-latitude')),
      longitude: parseFloat(element.dataset.longitude || element.getAttribute('data-longitude')),
      localTime: element.dataset.localTime || element.getAttribute('data-local-time') || '',
    }
  }

  updateSelectOptionLabels() {
    if (!this.hasSelectTarget) return

    const selected = this.selectTarget.options[this.selectTarget.selectedIndex]

    for (const option of this.selectTarget.options) {
      const name = option.getAttribute('data-name')
      if (this.selectTarget.options.length > 1 && selected.value === option.value) {
        option.innerHTML = `${name} (+ ${this.selectTarget.options.length - 1} more)`
      } else {
        option.innerHTML = name
      }
    }
  }

  updateRegionButtonStates(activeButton) {
    this.regionButtonTargets.forEach((button) => {
      const isActive = button === activeButton
      button.classList.toggle('btn-neutral', isActive)
      button.classList.toggle('btn-outline', !isActive)
    })
  }

  renderTime(region) {
    const hasTime = region.localTime?.length > 0
    this.timeTarget.classList.toggle('hidden', !hasTime)
    if (!hasTime) return

    this.nameTarget.innerHTML = region.name
    this.localTimeTarget.innerHTML = region.localTime
  }

  ensureMap() {
    if (!this.hasMapTarget || this.map) return

    this.map = new google.maps.Map(this.mapTarget, MAP_OPTIONS)
    this.circle = new google.maps.Circle({ ...CIRCLE_OPTIONS, map: this.map })
  }

  openModal(event) {
    this.selectRegion()
    event.preventDefault()
    $(this.modalTarget).addClass('active')
    $('body').addClass('modal-shown')
    return false
  }

  closeModal(event) {
    event.preventDefault()

    if (
      !$(event.target).hasClass('modal') &&
      !$(event.target).hasClass('close-modal') &&
      !$(event.target).hasClass('close-modal-button')
    )
      return

    $(this.modalTarget).removeClass('active')
    $('body').removeClass('modal-shown')
    return false
  }
}
